import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from './shared/services';
import { ThemeService } from './shared/services/theme.service';
import { Title } from '@angular/platform-browser';
import { AuthService, ScreenService } from 'grow-angular/services';
import { log } from 'src/debug';
import { GrowTokenService } from './shared/services/grow-token-service';
import { LauncherConfigService } from './shared/services/launcher.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { formatDate } from '@angular/common';
import { combineLatest } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private auth: AuthService,
    private themeService: ThemeService,
    private screenService: ScreenService,
    private userService: UserService,
    private growTokenService: GrowTokenService,
    private title: Title,
    private launcherConfigService: LauncherConfigService,
    private config: ConfigService
  ) {
    this.launcherConfigService.loadConfig('/maintenance');
  }
  adminBypassedMaintenance = false;
  showAdminContinueButton = false;
  timeFrom?: string;
  timeTo?: string;
  showMaintenancePage = false;
  ngOnInit() {
    this.addResizeHandler();

    this.configureTheme();
    this.title.setTitle(window.__CONFIG.TITLE || 'Memberservice');
    let token = this.auth.hasValidAccessToken();
    if (token) {
      this.loadUser();
      this.adminBypassedMaintenance = localStorage.getItem('adminBypassedMaintenance') === 'true';

      combineLatest([this.launcherConfigService.config$, this.launcherConfigService.adminBypassedMaintenance$])
        .pipe(filter(([cfg, _]) => !!cfg && !!cfg.From && !!cfg.To))
        .subscribe(([cfg, bypassed]) => {
          this.adminBypassedMaintenance = bypassed;
          const isAlreadyOnMaintenance = window.location.pathname.includes('/maintenance');
          const isAdmin = this.launcherConfigService.isAdmin;

          this.timeFrom = formatDate(cfg.From, 'yyyy-MM-dd HH:mm', 'en-US');
          this.timeTo = formatDate(cfg.To, 'yyyy-MM-dd HH:mm', 'en-US');

          const now = new Date();
          const from = new Date(this.timeFrom);
          const to = new Date(this.timeTo);

          if (now >= from && now <= to) {
            if (!isAlreadyOnMaintenance && !bypassed) {
              window.location.href = '/maintenance';
            }

            if (isAdmin && !bypassed && !isAlreadyOnMaintenance) {
              this.showAdminContinueButton = true;
            }

            if (isAlreadyOnMaintenance) {
              this.showMaintenancePage = true;
            }
          } else {
            localStorage.removeItem('adminBypassedMaintenance');
            if (isAlreadyOnMaintenance) {
              window.location.href = '/';
            }
          }
        });
    }

    this.addStorageHandler();
  }

  private configureTheme() {
    this.themeService.setAppTheme(localStorage.getItem('default_theme'));
  }

  private addResizeHandler() {
    this.screenService._resize$.subscribe();
  }

  private addStorageHandler() {
    this.auth.addStorageStateHandler();
  }

  loadUser() {
    this.userService.getCurrentUser().subscribe();
  }

  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    if (event.data && event.data.type === 'auth:session_expired') {
      this.auth.initLogInFlow();
    }
  }
}
